import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { createNoDashGuid, Deferred, Events } from "../common/Exports";
import { ConnectingToServiceEvent, ListeningStartedEvent, RecognitionStartedEvent, RecognitionTriggeredEvent } from "./RecognitionEvents";
import { ServiceTelemetryListener } from "./ServiceTelemetryListener.Internal";
export var RequestSession = /*#__PURE__*/function () {
  function RequestSession(audioSourceId) {
    var _this = this;

    _classCallCheck(this, RequestSession);

    this.privIsDisposed = false;
    this.privDetachables = new Array();
    this.privIsAudioNodeDetached = false;
    this.privIsRecognizing = false;
    this.privIsSpeechEnded = false;
    this.privTurnStartAudioOffset = 0;
    this.privLastRecoOffset = 0;
    this.privHypothesisReceived = false;
    this.privBytesSent = 0;
    this.privRecogNumber = 0;

    this.onAudioSourceAttachCompleted = function (audioNode, isError, error) {
      _this.privAudioNode = audioNode;
      _this.privIsAudioNodeDetached = false;

      if (isError) {
        _this.onComplete();
      } else {
        _this.onEvent(new ListeningStartedEvent(_this.privRequestId, _this.privSessionId, _this.privAudioSourceId, _this.privAudioNodeId));
      }
    };

    this.onPreConnectionStart = function (authFetchEventId, connectionId) {
      _this.privAuthFetchEventId = authFetchEventId;
      _this.privSessionId = connectionId;

      _this.onEvent(new ConnectingToServiceEvent(_this.privRequestId, _this.privAuthFetchEventId, _this.privSessionId));
    };

    this.onAuthCompleted = function (isError, error) {
      if (isError) {
        _this.onComplete();
      }
    };

    this.onConnectionEstablishCompleted = function (statusCode, reason) {
      if (statusCode === 200) {
        _this.onEvent(new RecognitionStartedEvent(_this.requestId, _this.privAudioSourceId, _this.privAudioNodeId, _this.privAuthFetchEventId, _this.privSessionId));

        if (!!_this.privAudioNode) {
          _this.privAudioNode.replay();
        }

        _this.privTurnStartAudioOffset = _this.privLastRecoOffset;
        _this.privBytesSent = 0;
        return;
      } else if (statusCode === 403) {
        _this.onComplete();
      }
    };

    this.onServiceTurnEndResponse = function (continuousRecognition) {
      if (!continuousRecognition || _this.isSpeechEnded) {
        _this.onComplete();
      } else {
        // Start a new request set.
        _this.privTurnStartAudioOffset = _this.privLastRecoOffset;
        _this.privRequestId = createNoDashGuid();

        _this.privAudioNode.replay();
      }
    };

    this.dispose = function (error) {
      if (!_this.privIsDisposed) {
        // we should have completed by now. If we did not its an unknown error.
        _this.privIsDisposed = true;

        var _iterator = _createForOfIteratorHelper(_this.privDetachables),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var detachable = _step.value;
            detachable.detach();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        _this.privServiceTelemetryListener.dispose();
      }
    };

    this.getTelemetry = function () {
      if (_this.privServiceTelemetryListener.hasTelemetry) {
        return _this.privServiceTelemetryListener.getTelemetry();
      } else {
        return null;
      }
    };

    this.onEvent = function (event) {
      if (!!_this.privServiceTelemetryListener) {
        _this.privServiceTelemetryListener.onEvent(event);
      }

      Events.instance.onEvent(event);
    };

    this.onComplete = function () {
      if (!!_this.privIsRecognizing) {
        _this.privIsRecognizing = false;

        _this.detachAudioNode();
      }
    };

    this.detachAudioNode = function () {
      if (!_this.privIsAudioNodeDetached) {
        _this.privIsAudioNodeDetached = true;

        if (_this.privAudioNode) {
          _this.privAudioNode.detach();
        }
      }
    };

    this.privAudioSourceId = audioSourceId;
    this.privRequestId = createNoDashGuid();
    this.privAudioNodeId = createNoDashGuid();
    this.privRequestCompletionDeferral = new Deferred();
  }

  _createClass(RequestSession, [{
    key: "listenForServiceTelemetry",
    value: function listenForServiceTelemetry(eventSource) {
      if (!!this.privServiceTelemetryListener) {
        this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
      }
    }
  }, {
    key: "startNewRecognition",
    value: function startNewRecognition() {
      this.privIsSpeechEnded = false;
      this.privIsRecognizing = true;
      this.privTurnStartAudioOffset = 0;
      this.privLastRecoOffset = 0;
      this.privRequestId = createNoDashGuid();
      this.privRecogNumber++;
      this.privServiceTelemetryListener = new ServiceTelemetryListener(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
      this.onEvent(new RecognitionTriggeredEvent(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
  }, {
    key: "onHypothesis",
    value: function onHypothesis(offset) {
      if (!this.privHypothesisReceived) {
        this.privHypothesisReceived = true;
        this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
      }
    }
  }, {
    key: "onPhraseRecognized",
    value: function onPhraseRecognized(offset) {
      this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
      this.onServiceRecognized(offset);
    }
  }, {
    key: "onServiceRecognized",
    value: function onServiceRecognized(offset) {
      this.privLastRecoOffset = offset;
      this.privHypothesisReceived = false;
      this.privAudioNode.shrinkBuffers(offset);
    }
  }, {
    key: "onAudioSent",
    value: function onAudioSent(bytesSent) {
      this.privBytesSent += bytesSent;
    }
  }, {
    key: "onStopRecognizing",
    value: function onStopRecognizing() {
      this.onComplete();
    } // Should be called with the audioNode for this session has indicated that it is out of speech.

  }, {
    key: "onSpeechEnded",
    value: function onSpeechEnded() {
      this.privIsSpeechEnded = true;
    }
  }, {
    key: "sessionId",
    get: function get() {
      return this.privSessionId;
    }
  }, {
    key: "requestId",
    get: function get() {
      return this.privRequestId;
    }
  }, {
    key: "audioNodeId",
    get: function get() {
      return this.privAudioNodeId;
    }
  }, {
    key: "completionPromise",
    get: function get() {
      return this.privRequestCompletionDeferral.promise();
    }
  }, {
    key: "isSpeechEnded",
    get: function get() {
      return this.privIsSpeechEnded;
    }
  }, {
    key: "isRecognizing",
    get: function get() {
      return this.privIsRecognizing;
    }
  }, {
    key: "currentTurnAudioOffset",
    get: function get() {
      return this.privTurnStartAudioOffset;
    }
  }, {
    key: "recogNumber",
    get: function get() {
      return this.privRecogNumber;
    } // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.

  }, {
    key: "bytesSent",
    get: function get() {
      return this.privBytesSent;
    }
  }]);

  return RequestSession;
}();